import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions, TrelloSuspenseQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const MemberAtlassianIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MemberAtlassianId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"aaId"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"MemberAtlassianId","document":MemberAtlassianIdDocument}} as const;
export type MemberAtlassianIdQueryVariables = Types.Exact<{
  memberId: Types.Scalars['ID']['input'];
}>;


export type MemberAtlassianIdQuery = (
  { __typename: 'Query' }
  & { member?: Types.Maybe<(
    { __typename: 'Member' }
    & Pick<Types.Member, 'id' | 'aaId'>
  )> }
);

/**
 * __useMemberAtlassianIdQuery__
 *
 * To run a query within a React component, call `useMemberAtlassianIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberAtlassianIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberAtlassianIdQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useMemberAtlassianIdQuery(
  baseOptions: TrelloQueryHookOptions<
    MemberAtlassianIdQuery,
    MemberAtlassianIdQueryVariables
  > &
    (
      | { variables: MemberAtlassianIdQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: MemberAtlassianIdDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    MemberAtlassianIdQuery,
    MemberAtlassianIdQueryVariables
  >(MemberAtlassianIdDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useMemberAtlassianIdLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    MemberAtlassianIdQuery,
    MemberAtlassianIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MemberAtlassianIdQuery,
    MemberAtlassianIdQueryVariables
  >(MemberAtlassianIdDocument, options);
}
export function useMemberAtlassianIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | TrelloSuspenseQueryHookOptions<
        MemberAtlassianIdQuery,
        MemberAtlassianIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MemberAtlassianIdQuery,
    MemberAtlassianIdQueryVariables
  >(MemberAtlassianIdDocument, options);
}
export type MemberAtlassianIdQueryHookResult = ReturnType<
  typeof useMemberAtlassianIdQuery
>;
export type MemberAtlassianIdLazyQueryHookResult = ReturnType<
  typeof useMemberAtlassianIdLazyQuery
>;
export type MemberAtlassianIdSuspenseQueryHookResult = ReturnType<
  typeof useMemberAtlassianIdSuspenseQuery
>;
export type MemberAtlassianIdQueryResult = Apollo.QueryResult<
  MemberAtlassianIdQuery,
  MemberAtlassianIdQueryVariables
>;
